import { defineStore } from 'pinia'
import repositoryFactory from '@/factories/repository-factory'
import NewsRepository from '@/repositories/news-repository'
import News from '@/models/News'
import { useInitDataStore } from '@/stores/initDataStore'

const storeKey = 'news'

export const useNewsHistoryStore = defineStore(storeKey, {
  state: () => ({
    newsHistory: {} as News,
    newsCurrent: {} as News,
  }),

  getters: {
    has10DaysNews: state => () => {
      return state.newsCurrent.has10DaysNews && state.newsCurrent.has10DaysNews()
    },
  },

  actions: {
    async history(date: Date = new Date()) {
      const repository = (await repositoryFactory.create()).get(storeKey) as NewsRepository
      const initDataStore = useInitDataStore()
      const notificationId = initDataStore.initData.systemInfo.notification?.id

      if (notificationId === undefined) {
        return
      }

      this.newsHistory = await repository.history(notificationId, date)

      return this.newsHistory
    },

    async fetch() {
      const repository = (await repositoryFactory.create()).get(storeKey) as NewsRepository
      const initDataStore = useInitDataStore()
      const notificationId = initDataStore.initData.systemInfo.notification?.id

      if (notificationId === undefined) {
        return
      }

      this.newsCurrent = await repository.fetch(notificationId)

      return this.newsCurrent
    },

    async delete(id: number) {
      const repository = (await repositoryFactory.create()).get(storeKey) as NewsRepository
      const initDataStore = useInitDataStore()
      const notificationId = initDataStore.initData.systemInfo.notification?.id

      if (notificationId === undefined) {
        return
      }

      await repository.delete(notificationId, id)

      this.newsHistory.delete(id)
    },

    findById(id: number) {
      return this.newsHistory.findById(id)
    },
  },
})
